import { useQuery } from '@apollo/client';
import { GET_ADMIN_USER_GAME_SERIES } from '../graphql/Queries';

export interface UserGameDailyPoint {
  date: string;
  starts: number;
  wins: number;
  hint1Count: number;
  hint2Count: number;
  hint3Count: number;
  medianElapsedTimeMs: number | null;
}

interface AdminUserGameSeriesData {
  adminUserGameSeries: {
    success: boolean;
    errors?: string[];
    classic: UserGameDailyPoint[];
    casual: UserGameDailyPoint[];
  };
}

interface AdminUserGameSeriesVars {
  days?: number;
}

export function useAdminUserGameSeries(days: number = 30) {
  return useQuery<AdminUserGameSeriesData, AdminUserGameSeriesVars>(
    GET_ADMIN_USER_GAME_SERIES,
    {
      variables: { days },
    }
  );
}
